import React from 'react';
import {
    updateAuthDataNEWRS,
    updateEmailInModal,
    updateShowAuthModalRS,
    updateShowLoginLinkModal,
} from "../../redux/reduxActions/reduxStoreActions";
import {useDispatch, useSelector} from "react-redux";
import {hasAValue} from "../../uitls/SharedFunctions";
import {stringsTranslate} from "../../locales/CustomTranslater";
import {appLanguage, appWords} from "../../config/Constants";
import {afterLogoutAlertFunction} from "../../uitls/AlertFunctions";
import { useHandleLinkClick } from '../../hooks/useHandleLinkClick';


export default function HeaderBE({switchLanguage}) {
    const s = useSelector(state => state.emailInModalRS);
    const handleLinkClick2 = useHandleLinkClick();

    const handleLinkClick = (link) => {
        handleLinkClick2(link)
        document.querySelector('.navbar').classList.remove('active')
        document.querySelector('body').classList.remove('canvas-open')
        document.querySelector('.navbar-toggler-icon').classList.remove('active')
    };

    const initStrings = {
        element1: stringsTranslate(appWords.store_discounts_cl),
        element2: stringsTranslate(appWords.online_discounts_cl),
        element3: stringsTranslate(appWords.student_jobs_cl),
        element4: stringsTranslate(appWords.knaek_order),
        element5: stringsTranslate(appWords.download_app),
        element6: stringsTranslate(appWords.more),
        subElements6: {
            item0: stringsTranslate(appWords.login_cl),
            item1: stringsTranslate(appWords.for_companies),
            item2: stringsTranslate(appWords.who_are_we),
            item3: stringsTranslate(appWords.our_partner),
            item4: "Knaek.box",
            item5: stringsTranslate(appWords.contact_faq),
            item6: stringsTranslate(appWords.logout),
            item7: stringsTranslate(appWords.profile),
            // item8: "Download app",
        },
    }
    const dispatch = useDispatch()
    const authDataRS = useSelector(state => state.authDataNEWRS);

    return (
        <header className="navbar navbar-sticky navbar-expand-lg bg-gradient navbar-dark navbar-custom-style">
            <div className="container-fluid position-relative">
                <a aria-label="navbar-brand cursor-pointer"   onClick={() => handleLinkClick("/")} className="logo">
                    <span className="cursor-pointer" style={{color: '#fff', fontFamily: 'Poppins', fontWeight: 700, fontSize: '24px', letterSpacing: '0.5px'}}>Buurtblij</span>
                </a>

                <button className="navbar-toggler" type="button" data-toggle="navbarToggler">
                    <span className="navbar-toggler-icon ml-4"/>
                </button>

                {/*Mobile sidebar*/}
                <div className="navbar-inner d-flex justify-content-center">
                    <nav>
                        <ul className="navbar-nav" id="navbar-nav">
                            <li className="nav-item">
                                <a className="nav-link  nav-line cursor-pointer"  onClick={() => handleLinkClick("/studentenkorting")}>{initStrings.element1}</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link  nav-line cursor-pointer"  onClick={() => handleLinkClick("/cashback/studentenkorting")}>{initStrings.element2}</a>
                            </li>

                            {/*<li className="nav-item">*/}
                            {/*    <a className="nav-link  nav-line cursor-pointer"  onClick={() => handleLinkClick("/bijbaan")}>{initStrings.element3}</a>*/}
                            {/*</li>*/}
                            <li className="nav-item">
                                <a className="nav-link  nav-line cursor-pointer"  onClick={() => handleLinkClick("/download-app")}>{initStrings.element5}</a>
                            </li>


                            <li className="nav-item dropdown ">
                                <a className="nav-link dropdown-toggle nav-line cursor-pointer"  onClick={() => handleLinkClick("/")} id="navbarDropdownMenuLink"
                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {initStrings.element6}
                                </a>
                                <ul className="dropdown-menu shadow " aria-labelledby="navbarDropdownMenuLink">
                                    {!hasAValue(authDataRS) && <li>
                                        <a className="dropdown-item nav-line pt-3"
                                           onClick={()=> {
                                            if(s) {
                                                dispatch(updateShowLoginLinkModal(true))
                                                return
                                            }
                                            dispatch(updateShowAuthModalRS(true))
                                           }}>{initStrings.subElements6.item0}</a>
                                    </li>}

                                    {hasAValue(authDataRS) && <li>
                                        <a className="dropdown-item nav-line pt-3 cursor-pointer"  onClick={() => handleLinkClick("/account")}>{initStrings.subElements6.item7}</a>
                                    </li>}

                                    <li>
                                        <a className="dropdown-item nav-line cursor-pointer" onClick={() => handleLinkClick("/studentenkorting-geven")}>{initStrings.subElements6.item1}</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item nav-line cursor-pointer" onClick={() => handleLinkClick("/wie-zijn-wij")}>{initStrings.subElements6.item2}</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item nav-line  cursor-pointer" onClick={() => handleLinkClick("/partners-van-knaek")}>{initStrings.subElements6.item3}</a>
                                    </li>
                                    {/*<li>*/}
                                    {/*    <a className="dropdown-item nav-line cursor-pointer"*/}
                                    {/*       href="https://knaekbox.nl/en">{initStrings.subElements6.item4}</a>*/}
                                    {/*</li>*/}
                                    <li>
                                        <a className="dropdown-item nav-line cursor-pointer" onClick={() => handleLinkClick("/contact")}>{initStrings.subElements6.item5}</a>
                                    </li>
                                    {/*<li>*/}
                                    {/*    <a className="dropdown-item nav-line"*/}
                                    {/*       to="/download-app">{initStrings.subElements6.item8}</a>*/}
                                    {/*</li>*/}
                                    {hasAValue(authDataRS) && <li>
                                        <a className="dropdown-item nav-line"
                                           onClick={()=> {
                                               dispatch(updateAuthDataNEWRS(null))
                                               dispatch(updateEmailInModal(null));
                                               afterLogoutAlertFunction()
                                           }}>{initStrings.subElements6.item6}</a>
                                    </li>}
                                </ul>

                            </li>

                            <li className={"nav-item d-flex justify-content-center align-items-center m-2"}>
                                <div className="d-flex justify-content-center align-items-center btn-transparent btn-homepage-appstore">
                                    <a className="position-relative"
                                       onClick={()=> switchLanguage(appLanguage.be)}>
                                        <img src="/assets/images/flags/be_9928ec3018.svg"
                                             alt="be" className="position-relative" width="25" height="17"/>
                                    </a>
                                    <a className="position-relative"
                                       onClick={()=> switchLanguage(appLanguage.en)}>
                                        <img src="/assets/images/flags/english_2b352b017b.svg"
                                             alt="Nederlands" className="position-relative" width="25" height="17"/>
                                    </a>
                               
                                </div>
                            </li>
                            <li className={"nav-item ml-2 d-flex justify-content-center align-items-center m-2"}>
                                <div
                                    className="d-flex justify-content-center align-items-center btn-transparent btn-homepage-appstore">
                                    <a className="position-relative nav-link  nav-line cursor-pointer" onClick={() => handleLinkClick("/bestellen")}>{initStrings.element4}</a>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    );
}
